import React from 'react';
import {
    Show, 
    TextField,
    TopToolbar,
    EditButton,
    DeleteButton
} from 'react-admin';
import VersionTitle from './fields/versionTitle.component';
import DefaultPlaceholderField from '../../material/defPlaceholderField.component';
import YesNoField from '../../material/yesNoField.component';
import { versionsFields } from '../versions.model';
import VersionPlatform from './fields/versionPlatform.component';
import VersionAppType from './fields/versionAppType.component';
import { SectionedShowLayout, LabeledField } from '../../components/layouts';

const ShowActions = () => (
    <TopToolbar>
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
    </TopToolbar>
);

const VersionShow = () => {
    const sections = [
        {
            title: "Version Information",
            fields: [
                <LabeledField key="id" label="Id">
                    <DefaultPlaceholderField source={versionsFields.id} wrapField={<TextField/>} />
                </LabeledField>,
                <LabeledField key="platform" label="Platform">
                    <VersionPlatform />
                </LabeledField>,
                <LabeledField key="appType" label="App Type">
                    <VersionAppType />
                </LabeledField>,
                <LabeledField key="version" label="Version">
                    <DefaultPlaceholderField source={versionsFields.version} wrapField={<TextField/>} />
                </LabeledField>,
                <LabeledField key="build" label="Build">
                    <DefaultPlaceholderField source={versionsFields.build} wrapField={<TextField/>} />
                </LabeledField>,
                <LabeledField key="forceUpdate" label="Force Update">
                    <YesNoField source={versionsFields.forceUpdate} />
                </LabeledField>
            ]
        },
        {
            title: "Release Details",
            fields: [
                <LabeledField key="releaseNotes" label="Release Notes">
                    <DefaultPlaceholderField source={versionsFields.releaseNotes} wrapField={<TextField/>} />
                </LabeledField>
            ]
        }
    ];

    return (
        <Show 
            title={<VersionTitle />} 
            actions={<ShowActions />}
        >
            <SectionedShowLayout sections={sections} />
        </Show>
    );
};

export default VersionShow;
